import styled from "styled-components";
import * as RadixTooltip from "@radix-ui/react-tooltip";
import { ZIndex } from "../../constants";
import { typographyMixin, colorMixin } from "../../helpers";

export const TooltipContent = styled(RadixTooltip.Content)`
    ${typographyMixin("label-x-small-medium")};
    z-index: ${ZIndex.TOOLTIP};
    padding: 8px 12px;
    border-radius: 8px;
    user-select: none;
    color: ${colorMixin("text-primary-900")};
    background: ${colorMixin("background-primary-base")};
    filter: drop-shadow(0px 8px 16px rgba(83, 86, 88, 0.1));
    animation-duration: 400ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    will-change: transform, opacity;

    @keyframes slideUpAndFade {
        from {
            opacity: 0;
            transform: translateY(2px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideRightAndFade {
        from {
            opacity: 0;
            transform: translateX(-2px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    @keyframes slideDownAndFade {
        from {
            opacity: 0;
            transform: translateY(-2px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideLeftAndFade {
        from {
            opacity: 0;
            transform: translateX(2px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    [data-state="delayed-open"][data-side="top"] {
        animation-name: slideDownAndFade;
    }

    [data-state="delayed-open"][data-side="right"] {
        animation-name: slideLeftAndFade;
    }

    [data-state="delayed-open"][data-side="bottom"] {
        animation-name: slideUpAndFade;
    }

    [data-state="delayed-open"][data-side="left"] {
        animation-name: slideRightAndFade;
    }
`;

export const TooltipArrow = styled(RadixTooltip.Arrow)`
    fill: ${colorMixin("background-primary-base")};
    filter: drop-shadow(0px 8px 16px rgba(83, 86, 88, 0.1));
`;
